// src/utils/validazionePiva.js
// Verifica formale della Partita IVA italiana — algoritmo ufficiale (variante Modulo
// Luhn), verificato con due P.IVA reali diverse durante lo sviluppo (03231640487,
// 07643520567). Nessun servizio esterno: calcolo puramente locale, verifica solo la
// correttezza formale del numero — non che l'azienda esista davvero o sia ancora
// attiva (per quello servirebbe una verifica presso l'Agenzia delle Entrate, fuori
// scopo qui: l'obiettivo è solo impedire che il campo P.IVA venga riempito con una
// sequenza a caso di cifre).
export function pivaValida(piva) {
  const p = (piva || "").replace(/\D/g, ""); // toglie IT, spazi, punti — resta solo le cifre
  if (p.length !== 11) return false;
  let somma = 0;
  for (let i = 0; i < 10; i += 2) somma += parseInt(p[i], 10);
  for (let i = 1; i < 10; i += 2) {
    let doppio = parseInt(p[i], 10) * 2;
    if (doppio > 9) doppio -= 9;
    somma += doppio;
  }
  const cifraControllo = (10 - (somma % 10)) % 10;
  return cifraControllo === parseInt(p[10], 10);
}

// Verifica formale del Codice Fiscale italiano (16 caratteri) — per chi, come libero
// professionista, usa il proprio CF al posto di una P.IVA numerica separata. Algoritmo
// ufficiale (DM 12/3/1974), verificato con due Codici Fiscali reali da fonti diverse
// (RSSMRA85M01H501Q, RCCMNL83S18D969H). Stesso principio della P.IVA: controlla solo la
// correttezza formale (il carattere di controllo torna), non che la persona esista
// davvero — per quello serve l'Agenzia delle Entrate.
const TABELLA_DISPARI = {
  "0":1,"1":0,"2":5,"3":7,"4":9,"5":13,"6":15,"7":17,"8":19,"9":21,
  A:1,B:0,C:5,D:7,E:9,F:13,G:15,H:17,I:19,J:21,K:2,L:4,M:18,N:20,O:11,P:3,Q:6,R:8,S:12,T:14,U:16,V:10,W:22,X:25,Y:24,Z:23,
};
const TABELLA_PARI = {
  "0":0,"1":1,"2":2,"3":3,"4":4,"5":5,"6":6,"7":7,"8":8,"9":9,
  A:0,B:1,C:2,D:3,E:4,F:5,G:6,H:7,I:8,J:9,K:10,L:11,M:12,N:13,O:14,P:15,Q:16,R:17,S:18,T:19,U:20,V:21,W:22,X:23,Y:24,Z:25,
};
export function codiceFiscaleValido(cf) {
  const c = (cf || "").trim().toUpperCase();
  if (c.length !== 16 || !/^[A-Z0-9]{16}$/.test(c)) return false;
  let somma = 0;
  for (let i = 0; i < 15; i++) {
    somma += (i % 2 === 0) ? TABELLA_DISPARI[c[i]] : TABELLA_PARI[c[i]];
  }
  const letteraAttesa = String.fromCharCode(65 + (somma % 26));
  return letteraAttesa === c[15];
}
